import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import selectors from './ClinicSelectors';

const onShowFilters = () => {
	disableBodyScroll(selectors.ELEMENTS.mobileFilters);

	/**
	 * `timeout` is `null` so that animation can start immediately in the next event cycle(when other elements are rendered)
	 */
	setTimeout(() => {
		// class for button animation
		selectors.ELEMENTS.hideFilters.forEach((e) => e?.classList.add(selectors.CLASSES.active));
	}, null);

	selectors.ELEMENTS.navigation.classList.add(selectors.CLASSES.displayNone);
	// filters
	selectors.ELEMENTS.mobileFilters.classList.add(selectors.CLASSES.active);
	// options
	selectors.ELEMENTS.showFilters.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.showSort.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.hideFiltersContainer.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.hideFilters.forEach((e) => e?.classList.remove(selectors.CLASSES.displayNone));
	selectors.ELEMENTS.clearFilters.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.saveFilters.classList.remove(selectors.CLASSES.displayNone);
	// info
	selectors.ELEMENTS.infoFilters.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.labelFilters.classList.remove(selectors.CLASSES.displayNone);
	// breadcrumb
	selectors.ELEMENTS.breadcrumb.classList.add(selectors.CLASSES.displayNone);
	// search toggle
	selectors.ELEMENTS.searchBtnTrigger?.classList.add(selectors.CLASSES.displayNone);
	// search form
	selectors.ELEMENTS.searchForm?.classList.add(selectors.CLASSES.displayNone);
};

const onHideFilters = () => {
	enableBodyScroll(selectors.ELEMENTS.mobileFilters);
	// animated element
	selectors.ELEMENTS.hideFilters.forEach((e) => e?.classList.remove(selectors.CLASSES.active));
	// when animation is done, handle other elements
};

const helperOnHideFilters = () => {
	selectors.ELEMENTS.navigation.classList.remove(selectors.CLASSES.displayNone);
	// filters
	selectors.ELEMENTS.mobileFilters.classList.remove(selectors.CLASSES.active);
	// options
	selectors.ELEMENTS.showFilters.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.hideFiltersContainer.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.hideFilters.forEach((e) => e?.classList.add(selectors.CLASSES.displayNone));
	selectors.ELEMENTS.clearFilters.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.saveFilters.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.showSort.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.clearSort.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.saveSort.classList.add(selectors.CLASSES.displayNone);
	// info
	selectors.ELEMENTS.infoFilters.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.labelFilters.classList.add(selectors.CLASSES.displayNone);
	// breadcrumb
	selectors.ELEMENTS.breadcrumb.classList.remove(selectors.CLASSES.displayNone);
	// search toggle
	selectors.ELEMENTS.searchBtnTrigger?.classList.remove(selectors.CLASSES.displayNone);
	// search form
	selectors.ELEMENTS.searchForm?.classList.remove(selectors.CLASSES.displayNone);
};

export default {
	onShowFilters,
	onHideFilters,
	helperOnHideFilters,
};
